module.exports = __webpack_public_path__ + "img/male9.536e219a.jpeg";